import $ from 'jquery';

export default function (conf) {
    let selector = '';
    if (conf !== undefined) {
        selector = conf.selector + ' ';
    }
    $(() => {
        var $body = $(`${selector}.article-content.post-body`);
        var $firstChild = $($(`${selector}.article-content.post-body .text-wrapper`).children()[1]);

        if ($firstChild.filter('figure').length > 0) {
            $firstChild.css({
                marginTop: '38px'
            });
            $body.addClass('no-accent');
        }
    });
}

